import { useState } from 'react';
import { GlobalButton, DateInput, SelectInput } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { Search as SearchIcon, DeleteForever as TrashIcon } from '@mui/icons-material';
import {
  ExportJobStatus,
  ExportKind,
  EXPORT_JOB_STATUS_LABELS,
  EXPORT_KIND_LABELS,
  type ExportJobsFilters,
} from '../models/ExportJob';

const statusOptions = [
  { label: 'Todos los estados', value: '' },
  ...Object.values(ExportJobStatus).map((s) => ({
    label: EXPORT_JOB_STATUS_LABELS[s],
    value: s,
  })),
];

interface ExportJobsFiltersProps {
  onSearch: (filters: ExportJobsFilters) => void;
  allowedKinds?: ExportKind[];
}

const ExportJobsFiltersBar = ({ onSearch, allowedKinds }: ExportJobsFiltersProps) => {
  const exportKindOptions = [
    { label: 'Todos los tipos', value: '' },
    ...(allowedKinds ?? Object.values(ExportKind)).map((k) => ({
      label: EXPORT_KIND_LABELS[k],
      value: k,
    })),
  ];
  const [local, setLocal] = useState<ExportJobsFilters>({
    status: '',
    exportKind: '',
    createdAtFrom: '',
    createdAtTo: '',
  });

  const handleSearch = () => onSearch(local);

  const handleReset = () => {
    const empty: ExportJobsFilters = { status: '', exportKind: '', createdAtFrom: '', createdAtTo: '' };
    setLocal(empty);
    onSearch(empty);
  };

  return (
    <div className='w-full p-5 flex flex-col justify-center bg-white rounded-lg shadow-md gap-5'>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
        <SelectInput
          name='export-kind-filter'
          placeholder='Tipo de exportación'
          options={exportKindOptions}
          value={local.exportKind ?? ''}
          onChange={(v) => setLocal((p) => ({ ...p, exportKind: String(v ?? '') as ExportKind | '' }))}
        />
        <SelectInput
          name='export-status-filter'
          placeholder='Estado'
          options={statusOptions}
          value={local.status ?? ''}
          onChange={(v) => setLocal((p) => ({ ...p, status: String(v ?? '') as ExportJobStatus | '' }))}
        />
        <DateInput
          name='created-from'
          placeholder='Creado desde'
          value={local.createdAtFrom ? new Date(local.createdAtFrom) : null}
          onChange={(d) => setLocal((p) => ({ ...p, createdAtFrom: d ? d.toISOString() : '' }))}
        />
        <DateInput
          name='created-to'
          placeholder='Creado hasta'
          value={local.createdAtTo ? new Date(local.createdAtTo) : null}
          onChange={(d) => setLocal((p) => ({ ...p, createdAtTo: d ? d.toISOString() : '' }))}
        />
      </div>
      <div className='flex gap-2 justify-end'>
        <GlobalButton variant={GlobalButtonVariant.secondaryButton} action={handleReset}>
          <TrashIcon />
          Limpiar
        </GlobalButton>
        <GlobalButton variant={GlobalButtonVariant.primaryButton} action={handleSearch}>
          <SearchIcon />
          Buscar
        </GlobalButton>
      </div>
    </div>
  );
};

export default ExportJobsFiltersBar;
